import ky, { type KyInstance } from 'ky';

export type TokenProvider = () => Promise<string | null | undefined>;

/**
 * Creates a Ky HTTP client that fetches the bearer token via `getToken` on every
 * request. In dev, `VITE_USE_MOCK_AUTH=true` short-circuits the provider to emit
 * a stable fake JWT matching the backend mock user.
 */
export function createApiClient(getToken: TokenProvider): KyInstance {
  const baseUrl = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5001';
  return ky.create({
    prefixUrl: baseUrl,
    timeout: 30_000,
    hooks: {
      beforeRequest: [
        async (request) => {
          const token = await getToken();
          if (token) {
            request.headers.set('Authorization', `Bearer ${token}`);
          }
        },
      ],
    },
  });
}

export const MOCK_JWT_TOKEN = 'mock-dev-jwt.user_local_dev';
